import { TransferAttendance } from "src/components/admin/student/attendances/transfer-attendance";
import Dashboard from "../components/coach/Dashboard";
import Profile from "../components/coach/Profile";

const routes = [
  { path: "/coach", exact: true, name: "Coach" },
  {
    path: "/coach/dashboard",
    exact: true,
    name: "Dashboard",
    component: Dashboard,
  },
  { path: "/coach/profile", exact: true, name: "Profile", component: Profile },
  {
    path: "/coach/attendance",
    exact: true,
    name: "coach attendance",
    component: TransferAttendance,
  },
];

export default routes;
